/**
 * Estimate reading time in minutes from markdown / plain text.
 * Strips markdown syntax then counts words; assumes ~220 wpm.
 */
export function estimateReadingTime(input: unknown, wpm = 220): number {
  let text = '';
  if (typeof input === 'string') text = input;
  else if (input && typeof input === 'object') {
    const obj = input as Record<string, any>;
    text = obj.en || obj.am || obj.om || JSON.stringify(obj);
  }
  const stripped = text
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]*`/g, ' ')
    .replace(/!\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)]\([^)]*\)/g, '$1')
    .replace(/[#>*_~`-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const words = stripped ? stripped.split(' ').length : 0;
  return Math.max(1, Math.round(words / wpm));
}
